/** @format */

const SearchFiltersTranslations = {
  en: {
    'SearchFilters.title': 'Optimize search',
    'SearchFilters.label.cost': 'Maximum Cost',
    'SearchFilters.label.rating': 'Rating',
    'SearchFilters.label.municipality': 'Municipality',
    'SearchFilters.label.task': 'Task',
    'SearchFilters.label.when': 'When',
    'SearchFilters.label.target': 'Target',
    'SearchFilters.label.payment': 'Payment',
  },

  it: {
    'SearchFilters.title': 'Ottimizza la ricerca',
    'SearchFilters.label.cost': 'Prezzo Max',
    'SearchFilters.label.rating': 'Valutazione',
    'SearchFilters.label.municipality': 'Municipio',
    'SearchFilters.label.task': 'Mansione',
    'SearchFilters.label.when': 'Quando',
    'SearchFilters.label.target': 'Per chi',
    'SearchFilters.label.payment': 'Pagamento',
  },
};

export default SearchFiltersTranslations;
